/* eslint-disable max-len */
import React from 'react';

interface IArrowProps {
    color?: string;
}

const Envelope: React.FC<IArrowProps> = ({color='#FE974A'}) => {

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_14765_216194)">
                <path
                    d="M6.47363 9.80371C6.48802 9.81297 6.50273 9.82256 6.51758 9.83105C6.96747 10.0882 7.48373 10.2187 8.00098 10.2188C8.51828 10.2187 9.03447 10.0883 9.48438 9.83105C9.49943 9.82244 9.51472 9.81309 9.5293 9.80371L16.001 5.6377V13.167C16.0008 13.9952 15.3292 14.6669 14.501 14.667H1.50098C0.672658 14.667 0.00115269 13.9953 0.000976562 13.167V5.63672L6.47363 9.80371ZM14.501 1.33301C15.3292 1.33315 16.0008 2.00482 16.001 2.83301V3.49316C15.795 3.4798 15.5834 3.52918 15.3965 3.64941L8.48145 8.09863C8.34871 8.17232 8.18158 8.21868 8.00098 8.21875C7.82001 8.21873 7.65243 8.17254 7.51953 8.09863L0.605469 3.64844C0.418745 3.52829 0.206752 3.47899 0.000976562 3.49219V2.83301C0.00115168 2.00473 0.672657 1.33301 1.50098 1.33301H14.501ZM16.001 3.49316C16.3067 3.513 16.5998 3.67179 16.7783 3.94922C17.0769 4.41354 16.9427 5.0322 16.4785 5.33105L16.001 5.6377V3.49316ZM0.000976562 5.63672L-0.476562 5.33008C-0.94091 5.03119 -1.07517 4.41262 -0.776367 3.94824C-0.597655 3.67064 -0.304989 3.5118 0.000976562 3.49219V5.63672Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_14765_216194">
                    <rect width="16" height="16" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default Envelope;